import React from "react";
import { LegacyCard, InlineGrid, Select } from "@shopify/polaris";
import CustomAutocomplete from "../CustomAutocomplete";
import { ButtonNumber } from "../CoatData";

const PalmJacketForm = ({ form, setForm, errors }) => {
  const sectionKey = "palmJacket";

  const handleChange = (key) => (values) => {
    const value = Array.isArray(values) ? values[0] : values;
    setForm((prev) => ({
      ...prev,
      [sectionKey]: {
        ...prev[sectionKey],
        [key]: value,
      },
    }));
  };

  return (
    <LegacyCard title="The Palm Jacket" sectioned>
      <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} gap="300">
        <Select
          label="Zipper"
          options={["Silver", "Gold"]}
          value={form[sectionKey]?.zipper || ""}
          onChange={handleChange("zipper")}
          error={errors[sectionKey]?.zipper}
        />
        <CustomAutocomplete
          label="Button Number"
          optionsList={ButtonNumber}
          onChange={handleChange("buttonNumber")}
          defaultValue={form[sectionKey]?.buttonNumber || ""}
        />
      </InlineGrid>
    </LegacyCard>
  );
};

export default PalmJacketForm;
